import { render, staticRenderFns } from "./reply-count.vue?vue&type=template&id=5b624aa4"
import script from "./reply-count.vue?vue&type=script&lang=js"
export * from "./reply-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports